import React from 'react';
import moment from 'moment';

class BusinessConfiguration extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);

    // NB: The values here correspond to the ReceiptType enum.  They need to
    // be kept in sync manually :p
    this.receiptValues = [
      {value: 'invoice', label: 'Invoice'},
      {value: 'receipt', label: 'Receipt'}
    ];
  }

  render() {
    const api = `/api/businesses/${this.props.businessUUID}/businessConfig`;
    const resetApi = `/api/businesses/${this.props.businessUUID}/resetBusinessConfig`;
    const fieldStyle = {display: 'flex', flexDirection: 'row'};

    return (
      <div className='padded-block'>
        <div className='form-header'>
          <admin.businesses.BusinessStatusBlock style={{marginLeft: 0}} businessUUID={this.props.businessUUID} />
          <waffle.misc.HeaderTitle title='Business POS Configuration' />
          <admin.businesses.BusinessConfigurationWarningBlock style={{marginLeft: 0}} businessUUID={this.props.businessUUID} />
        </div>
        <waffle.forms.Form
          ref='form'
          className='form'
          fetchAPI={api}
          dataPath='businessConfig.config'
          action={api}
        >
          <div style={fieldStyle}>
            <div>
              <waffle.forms.CheckBoxField
                name='inAppTipEntry'
                label='In app tip entry (enter how much they are paying on card)'
              />
              <waffle.forms.CheckBoxField
                name='onReaderTipEntry'
                label='On reader tip entry (customer can add tip from reader)'
              />
            </div>
          <div style={{width: '200px', paddingTop: '5px', paddingLeft: '50px'}}>
            <waffle.forms.SelectField
              name='receiptType'
              label='Receipt Type'
              options={this.receiptValues}
            />
          </div>
            </div>

          <div className='submit-actions'>
            <waffle.misc.FlatButton label='Save' type='submit' className='blue-background' />
            &nbsp;
            <waffle.buttons.ApiButton
              label='Reset to default'
              className='flat-button orange-background'
              api={resetApi}
              onSuccess={(result) => { this.refs.form.addNotification('success', result.message); }}
              onFailure={(result) => { this.refs.form.addNotification('danger', result.message); }}
            />
          </div>
        </waffle.forms.Form>
      </div>
    );
  }
}

class ContactList extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    const contacts = !!props.value ? props.value : [];

    this.state = {
      contacts
    };
  }

  addBlankContact() {
    const contacts = this.state.contacts;
    contacts.push({
      description: '',
      detail: '',
      isPreferredMethod: false
    });

    this.setState({
      contacts
    });
  }

  componentDidMount() {
    this.addBlankContact();
  }

  descriptionChanged(index, event) {
    const contacts = this.state.contacts;
    contacts[index].description = event.target.value;
    this.setState({
      contacts
    });
  }

  detailChanged(index, event) {
    const contacts = this.state.contacts;
    contacts[index].detail = event.target.value;
    this.setState({
      contacts
    });
  }

  preferredClicked(index, event) {
    const contacts = this.state.contacts;
    const wasPreferred = contacts[index].isPreferredMethod;

    if (wasPreferred) {
      contacts[index].isPreferredMethod = false;
    }
    else {
      for (let i = 0; i < contacts.length; i++) {
        contacts[i].isPreferredMethod = i === index;
      }
    }

    this.setState({
      contacts
    });
  }

  addContact() {
    // TODO We should do some validation
    this.addBlankContact();
  }

  deleteContact(index) {
    const contacts = this.state.contacts;
    contacts.splice(index, 1);
    this.setState({
      contacts
    });
  }

  renderContact(contact, index) {
    const checkedClass = contact.isPreferredMethod ? 'checked' : '';

    let action = <i onClick={this.deleteContact.bind(this, index)} className='delete icon-delete-garbage-streamline'></i>;

    if (index === this.state.contacts.length - 1) {
      action = <i onClick={this.addContact.bind(this)} className='add icon-add-square'></i>;
    }

    return (<div className='contact' key={index}>
      <div className='row'>
        <div className='col-xs-3'>
          <input onChange={this.descriptionChanged.bind(this, index)} className='form-control' placeholder='Description' name={`contact-${index}-name`} value={contact.description}></input>
        </div>
        <div className='col-xs-5'>
          <input onChange={this.detailChanged.bind(this, index)} className='form-control' placeholder='Email or phone number' name={`contact-${index}-detail`} value={contact.detail}></input>
        </div>
        <div className='col-xs-4'>
          <div className='checkbox-wrapper'>
            <input onClick={this.preferredClicked.bind(this, index)} type='checkbox' name={`contact-${index}-preferred`} checked={contact.isPreferredMethod} className={checkedClass}/>
            <label className={checkedClass} style={{marginTop: '0px'}}>
              <span></span>
              <div>Is Preferred</div>
            </label>
          </div>

          <div className='actions'>
            {
              action
            }
          </div>
        </div>
      </div>

    </div>);
  }

  render() {
    return (<div className='contact-list'>
      {
        this.state.contacts.map((contact, index) => {
          return this.renderContact(contact, index);
        })
      }
      <input type='hidden' name='contactList' value={JSON.stringify(this.state.contacts.slice(0, this.state.contacts.length - 1))} />
    </div>);
  }
}

class SendEMandateBlock extends waffle.blocks.SplitBlock {
  getContent() {
    return (
      <div className='padded-block'>
        <admin.businesses.BusinessStatusBlock businessUUID={this.props.businessUUID} style={{marginLeft: '0px'}} />
        <div className='form-header'>
          <waffle.misc.HeaderTitle title='Send Retail Capital eMandate' />
        </div>
        <waffle.forms.Form className='form half-width'
          action='/api/orders/sendRCEMandate'
          initialData={{businessUUID: this.props.businessUUID}}
        >
          <p>This will send the owner a Retail Capital eMandate, once they accept the terms we will be mailed a PDF copy. The cash advance amount is what the item is worth, we will still add the processing fee and interest later.</p>
          <waffle.forms.InputField name='cashAdvance' placeholder='Cash Advance (number only)' validators={[
            new waffle.forms.RequiredValidator('This field is required'),
            new waffle.forms.NumberValidator('This must be a number')
          ]} />
          <div className='submit-actions'>
            <waffle.misc.FlatButton label='Send' type='submit' className='blue-background' />
          </div>
        </waffle.forms.Form>
        <div className='form-header'>
          <waffle.misc.HeaderTitle title='Send eMandate' />
        </div>
        <p>This will send the owner an eMandate, once they accept the terms we will be mailed a PDF copy.</p>
        <waffle.forms.Form className='form half-width'
          action='/api/orders/sendEMandate'
          initialData={{businessUUID: this.props.businessUUID}}
        >
          <waffle.forms.InputField name='contractAmount' placeholder='Contract Amount (number only)' validators={[
            new waffle.forms.RequiredValidator('This field is required'),
            new waffle.forms.NumberValidator('This must be a number')
          ]} />
          <waffle.forms.InputField name='monthlyAmount' placeholder='Monthly Amount (number only)' validators={[
            new waffle.forms.RequiredValidator('This field is required'),
            new waffle.forms.NumberValidator('This must be a number')
          ]} />
          <waffle.forms.InputField name='months' placeholder='Over how many months' validators={[
            new waffle.forms.RequiredValidator('This field is required'),
            new waffle.forms.NumberValidator('This must be a number')
          ]} />
          <div className='submit-actions'>
            <waffle.misc.FlatButton label='Send' type='submit' className='blue-background' />
          </div>
        </waffle.forms.Form>
      </div>
    );
  }
}

class BusinessStatusBlock extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);

    this.fetchBusinessSummary();
    this.fetchCapitalSummary();
    this.fetchRemediationInfo();
  }

  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      businessStatus: undefined,
      remediationInfo: undefined
    });
  }

  render() {
    if (this.state.businessStatus === undefined) {

      return <div className='business-status-block'/>;
    }
    const businessName = this.state.businessStatus.name;
    const businessLink = <a href={`/businesses/${this.state.businessStatus.business.uuid}`}>{businessName}</a>
    const countryCode = this.state.businessStatus.business.businessLocalisation.countryCode;
    const countryCodeUpper = countryCode ? countryCode.toUpperCase() : "ZA";
    const bankAccount = this.state.businessStatus.bankAccount;
    const bankAccountUUID = bankAccount ? bankAccount.uuid :  null;

    const errors = [
      this.canBusinessTransact(),
      this.businessStatus(),
      this.riskState(),
      this.riskInvestigation(),
      this.vettingFailureReason(),
      this.vettingPrerequisites(),
      this.settlementActivated(),
      this.ficaVerified(),
      this.readersAllocated(),
      this.bankAccount(),
      this.failedPayout(),
      this.solePropAHVErrorMessage(),
    ].filter(result => !!result);

    // Transaction status
    let successfulCardTransactions = this.state.businessStatus.successfulCardTransactions;
    const outOfCardTransactions = this.state.businessStatus.outOfCardTransactions;

    const warnings = [];

    if (outOfCardTransactions > 0) {
      const successPercent = successfulCardTransactions * 100.0 / outOfCardTransactions;

      if (successPercent < 90) {
        warnings.push(
          <div className='business-problem'>Only {successfulCardTransactions} successful transactions out of last {outOfCardTransactions} ({successPercent.toFixed(1)}% successful)</div>
        );
      }
    }

    // if a business has any payout deduction plans, lets add them here
    if (this.state.businessPayoutDeductions){
      const {payoutDeductionState, principalAmount, totalAmountPaid} = this.state.businessPayoutDeductions;
      warnings.push(
        <div>{businessName} has a current payout deduction plan of R{principalAmount}, has paid off R{totalAmountPaid} and the state is <strong>{payoutDeductionState}</strong></div>
      );
    }

    // Hub onboarding status
    const hubOnboardingMetadata = this.state.businessStatus.business.info?.meta?.hubOnboardingMetadata;
    // If a business is still onboarding via Hub, add a warning.
    if (hubOnboardingMetadata && hubOnboardingMetadata.isOnboardingViaHub && !hubOnboardingMetadata.isOnboardingViaHubComplete) {
      warnings.push(
        <div><strong>{businessName} IS STILL ONBOARDING VIA HUB. UPDATES NOT ALLOWED.</strong></div>
        );
    }

    // Link to transaction metrics
    const filters = {
      phoneType: [],
      readerType: [],
      integration: [],
      cardType: [],
      cardScheme: [],
      businessUUID: [this.state.businessStatus.business.uuid],
    };

    const link = `/transactions/metrics?filters=${
      encodeURIComponent(JSON.stringify(filters))
      }&startDate=${encodeURIComponent(moment().subtract(1, 'months').format())
      }&endDate=${encodeURIComponent(moment().format())
      }&search=&columns=6&defaultRange=Today`;

    const remediationBanner = this.renderRemediationBanner();
    if (errors.length > 0) {
      return (
        <div>
          <div className='business-status-block alert alert-danger'>
            <div className='business-heading'>
              <i className='icon-alert'/> {this.addCountryFlag(countryCodeUpper)} {businessLink} has the following problems:
            </div>
            <div key='error-0'>{this.ownerWithNoSAID()}</div>
            {errors.map((error, index) => <div key={'error-' + index + 1}>{error}</div>)}
            <br />
            {warnings.map((warning, index) => <div key={'warning-' + index}>{warning}</div>)}
            {BusinessStatusBlock.updateRequestLink(this.state.businessStatus.updateRequest)}
            <a className='alert-link' href={link}>View transaction metrics for past month</a>
            {countryCodeUpper === "MU" && bankAccountUUID !== null ?
            <div>
              <a className='alert-link' href={`/bank-accounts/${bankAccountUUID}`}>Update business's banking details</a>
            </div>:
            <span/>}
          </div>
          {remediationBanner}
        </div>

      );
    } else {
      let alertType = 'alert-success';
      if (warnings.length > 0) {
        alertType = 'alert-warning';
      }

      return (
        <div>
          <div className={`business-status-block alert ${alertType}`}>
            <div className='business-heading'>
              <i className='icon-check-circle'/> {this.addCountryFlag(countryCodeUpper)} {businessName} is fully onboarded with no problems
            </div>
            <div key='warning-0'>{this.ownerWithNoSAID()}</div>
            {warnings.map((warning, index) => <div key={'warning-' + index + 1}>{warning}</div>)}
            {BusinessStatusBlock.updateRequestLink(this.state.businessStatus.updateRequest)}
            <a className='alert-link' href={link}>View transaction metrics for past month</a>
            {countryCodeUpper === "MU" && bankAccountUUID !== null ?
            <div>
              <a className='alert-link' href={`/bank-accounts/${bankAccountUUID}`}>Update business's banking details</a>
            </div>:
            <span/>}
          </div>
          {remediationBanner}
        </div>

      );
    }
  }

  renderRemediationBanner() {
    const remediationStatus = this.state.remediationInfo?.remediation?.status;

    const statusMessages = {
      requested: "Remediation is in progress",
      in_review: "Remediation is in review",
    };
  
    const remediationMessage = statusMessages[remediationStatus];
  
    if (!remediationMessage) return null;
  
    return (
      <div className='business-status-block alert alert-danger'>
        <div className='business-heading'>
          <i className='icon-alert' /> {remediationMessage}
        </div>
      </div>
    );
  }

  addCountryFlag(countryCodeUpper) {
    switch (countryCodeUpper) {
      case "EG": {
        return <span className="tag flag">ðªð¬</span>;
      }
      case "MU": {
        return <span className="tag flag">ð²ðº</span>;
      }
    }
    return <span className="tag flag">ð¿ð¦</span>;
  }

  settlementActivated() {
    if (!this.state.businessStatus.settlementActivated) {
      return <div className='business-problem'>Settlement not activated</div>;
    }
  }

  solePropAHVErrorMessage() {
    const {updateRequest, business} = this.state.businessStatus;

    const isSoleProp = business?.info?.businessType === 'sole_proprietor';
    const isApprovedWithoutIdMatch = updateRequest?.updateState === 'approved_without_id_match';

    if (isSoleProp && isApprovedWithoutIdMatch) {
      return <div className='business-problem'>Bank account is not in business owner's name</div>;
    }
  }

  vettingFailureReason() {
    if (this.state.businessStatus.vettingFailureReason) {
      return (
        <div className="business-problem">
          The business failed vetting: {this.state.businessStatus.vettingFailureReason}
        </div>
      )
    }
  }

  vettingPrerequisites() {
    if (this.state.businessStatus.vettingPrerequisites && this.state.businessStatus.length > 0) {
      return (
        <div className="business-problem">
          Vetting information not complete:
          <ul>
            {
              this.state.businessStatus.vettingPrerequisites.map(issue => {
                return <li>{issue}</li>
              })
            }
          </ul>
        </div>
      )
    }
  }

  ficaVerified() {
    if (!this.state.businessStatus.ficaVerification) {
      return <div className='business-problem'>Identification verification not started</div>;
    } else if (this.state.businessStatus.ficaVerification.status !== 'approved') {
      return <div className='business-problem'>Identification incomplete - '{this.state.businessStatus.ficaVerification.status}'</div>;
    }
  }

  readersAllocated() {
    const readers = this.state.businessStatus.readers || [];
    if (readers.length === 0) {
      return <div className='business-problem'>Business does not have any readers allocated to it</div>;
    }

    let hasAllocatedReader = false;
    for (const reader of readers) {
      if (reader.allocationState === 'allocated') {
        hasAllocatedReader = true;
      }
    }

    if (!hasAllocatedReader) {
      return <div className='business-problem'>Reader for business is not fully created and allocated</div>;
    }
  }

  bankAccount() {
    return !this.state.businessStatus.bankAccount || this.state.businessStatus.bankAccount.accountNumber === '' ?
      <div className='business-problem'>No settlement bank account has been put in place</div> : undefined;
  }

  riskState() {
    const businessRisk = this.state.businessStatus.businessRisk || {};

    if (!!businessRisk.riskState && businessRisk.riskState !== 'normal' && businessRisk.riskState !== 'suspicious') {
      const terminationReason = businessRisk.terminationReason ? `: ${businessRisk.terminationReason}` : '';
      
      if (businessRisk.riskState === 'under_risk_investigation') {
        return <div className='business-problem'><b>Under Transaction Review</b></div>;
      }

      return <div className='business-problem'><b>{businessRisk.riskState.humanize()}</b>{businessRisk.riskState === 'suspended' ? terminationReason : ''}</div>;
    }
  }

  riskInvestigation() {
    const riskInvestigation = this.state.businessStatus.latestRiskInvestigation;

    if (!riskInvestigation) {
      return null
    } else if (riskInvestigation.status === 'closed' || riskInvestigation.status === 'resolved') {
      if (
        riskInvestigation.result &&
          riskInvestigation.result != 'investigation_closed_not_fraud' &&
          riskInvestigation.result != 'investigation_closed_insufficient_evidence'
      ) {
        return <div className='business-problem'><b><a href={riskInvestigation.url}>Terminated for fraudulent behaviour</a></b></div>
      }
    } else {
      return <div className='business-problem'><b><a href={riskInvestigation.url}>Currently under risk investigation</a></b></div>
    }
  }

  canBusinessTransact() {
    if (!this.state.businessStatus.canBusinessTransact.canTransact) {
      const reasonMappings = {
        "onboarding_incomplete": "Merchant has not completed onboarding",
        "risk_transactions_disabled": "Risk has disabled transactions, contact the Risk Team",
        "risk_business_disabled": "Risk has disabled the business, contact the Risk Team",
        "business_rejected": "Business Status is 'Rejected'",
        "business_deactivated": "Business Status is 'Deactivated'"
      }
      return <div className="business-problem">Transactions are disabled: <b>{reasonMappings[this.state.businessStatus.canBusinessTransact.reason]}</b></div>
    }
  }

fetchRemediationInfo() {
      $.ajax({
        url: `/api/businesses/${this.props.businessUUID}/remediation`,
        dataType: 'json',
        type: 'GET'
      }).done((response) => {
        if (response.status === 200) {
          this.setState({
            remediationInfo: response.data
          });
        } else {
          radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        }
      }).fail((unused, textStatus) => {
        radio('showAlert').broadcast('danger', textStatus);
      });  
  }

  businessStatus() {
    if (this.state.businessStatus.businessDisabled) {
      return <div className="business-problem">Business is <b>{this.state.businessStatus.businessStatus}</b> ({this.state.businessStatus.businessStatusReason})</div>
    }
  }

  //mostRecentPayout will only be present if the most recent payout is unsuccessful
  failedPayout() {
    if (this.state.businessStatus.mostRecentPayout) {
        const dateCreated = this.state.businessStatus.mostRecentPayout.created;
        const formatDate =  moment(dateCreated).format("YYYY/MM/DD hh:mm:ss");
        return <div className='business-problem'>Most recent payout for {formatDate} has failed with state: <b>{this.state.businessStatus.mostRecentPayout.state}</b></div>;
    }
  }

  ownerWithNoSAID() {
    if (!this.state.businessStatus.business.owner.info.idNumber &&
        this.state.businessStatus.business.owner.info.passportNumber) {
      return <div className="business-problem">Non SA Owner</div>
    }
  }

  fetchCapitalSummary() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/lending/deductions/`,
      data : {
        filters: JSON.stringify({clientBusinessUUID: [ this.props.businessUUID ]})
      },
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        const capitalDeductionPlans = response.data.payoutDeductionPlans;
        const payoutDeduction = capitalDeductionPlans.find(plans => plans.clientBusinessUUID === this.props.businessUUID)

        this.setState({
          businessPayoutDeductions: payoutDeduction
        });
      } else if (response.status !== 403) {
        radio('showAlert').broadcast('danger', response.message);
      }
    }).fail((unused, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  fetchBusinessSummary() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/businesses/${this.props.businessUUID}/businessStatus/`,
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setState({
          businessStatus: response.data
        });
      } else if (response.status !== 403) {
        radio('showAlert').broadcast('danger', response.message);
      }
    }).fail((unused, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  static isUpdateRequestInComplete(updateRequest) {
    return !updateRequest ||
      (updateRequest.updateState !== 'approved' && updateRequest.updateState !=='declined');
  }

  static updateRequestLink(updateRequest) {
    if (!updateRequest) {
      return undefined;
    }
    const link = `/businesses/requests/${updateRequest.uuid}`;
    const processedAt = updateRequest.processedAt ? ` -- Latest update ${moment(updateRequest.processedAt, moment.ISO_8601).format('YYYY-MM-DD kk:mm')}` : ' -- No AHV data provided yet';
    const state = `${updateRequest.updateState.humanize()}${processedAt}`;

    return <div>
      <div className='business-status-block'>
        <a className='alert-link' href={link}>Latest bank account update request</a>: {`(${state})`}
      </div>
    </div>;
  }
}

class BusinessConfigurationWarningBlock extends waffle.base.BaseComponent {

  render() {

    const link = `/businesses/${this.props.businessUUID}/details/integrations`;

    return (
      <div className={`business-status-block alert alert-warning`}>
        <span> This configuration only applies to Yoco POS. For integration features go to Businesses > Details >  </span>
        <a className='alert-link' href={link}> SDK Configuration</a>
      </div>
    );
  }
}

class IntegrationConfiguration extends waffle.base.BaseComponent {

  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      integratorName: undefined
    });
  }

  canConfigureToken() {
    if (this.state.integratorName &&
      (
        this.state.integratorName.toLowerCase().indexOf('ikentoo') > -1
        || this.state.integratorName.toLowerCase().indexOf('yoco test') > -1
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  renderCantConfigure() {
    return (
      <div className='padded-block integrator-config-block'>
        No configuration options are available for the integration {this.state.integratorName}
      </div>
    );
  }

  render() {
    if (!this.canConfigureToken()) {
      return this.renderCantConfigure();
    }

    const fieldStyle = {display: 'flex', flexDirection: 'row'};
    const api = `/api/integration/sdkIntegrations/token/${this.props.businessUUID}?withIntegratorDetails=true`;

    return (<div className='padded-block integrator-config-block'>
      <div className='form-header'>
        <waffle.misc.HeaderTitle
          title={`${this.state.integratorName} SDK Integration Configuration`}
        />
      </div>
      <waffle.forms.Form
        ref='form'
        className='form'
        fetchAPI={api}
        dataPath='metadata.settings.paymentSettings.integration'
        action={api}
      >
        <div style={fieldStyle}>
          <div>
            <waffle.forms.CheckBoxField
              name='shouldUseAppSwitching'
              label='Use App Switching'
            />
            <waffle.forms.CheckBoxField
              name='offerTipEntry'
              label='Enable Tips From Reader'
            />
          </div>
        </div>
        <div className='submit-actions'>
          <waffle.misc.FlatButton label='Save' type='submit' className='blue-background' />
        </div>
      </waffle.forms.Form>
    </div>);
  }

  UNSAFE_componentWillMount() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/integration/sdkIntegrations/token/${this.props.businessUUID}`,
      dataType: 'json',
      data: 'withIntegratorDetails=true',
      type: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setState({
          integratorName: response.data.integratorSecret.name
        });
      } else {
        radio('showLoader').broadcast('danger', response.message);
      }
    }).fail((unused, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }
}

class BusinessStatus extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "rejected": {
        "text": "Rejected",
        "icon": "fa fa-times-circle",
        "class": "text-danger",
      },
      "active": {
        "text": "Active",
        "icon": "fa fa-check-square",
        "class": "text-success"
      },
      "inactive": {
        "text": "Event",
        "icon": "fa fa-clock-o",
        "class": "text-muted "
      },
      "churned": {
        "text": "Churned",
        "icon": "fa fa-exclamation-triangle",
        "class": "text-warning"
      },
      "deactivated": {
        "text": "Deactivated",
        "icon": "fa fa-times-circle",
        "class": "text-danger"
      }
    }
  }
}

class SaleType extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "online": {
        "text": "Online",
        "icon": "fa fa-chrome",
      },
      "yoco_store": {
        "text": "Yoco Store",
        "icon": "fa fa-shopping-bag",
        "class": "text-info"
      },
      "event": {
        "text": "Event",
        "icon": "fa fa-ticket",
        "class": "text-warning"
      },
      "retail": {
        "text": "Partner Retail",
        "icon": "fa fa-handshake-o",
        "class": "text-success"
      }
    }
  }
}

class SaleLocation extends waffle.misc.Enumerator {
  valueMap() {
    return {
      "yoco_online": {
        "text": "Yoco Online",
        "icon": "fa fa-chrome",
      },
      "yoco_store_johannesburg": {
        "text": "Yoco Store Johannesburg",
        "icon": "fa fa-shopping-bag",
        "class": "text-info"
      },
      "wefix": {
        "text": "WeFix",
      },
      "digicape": {
        "text": "Digicape",
      },
      "tabletpos": {
        "text": "TabletPOS",
      },
      "other": {
        "text": "Other",
      },
    }
  }
}

module.exports = {
  ContactList,
  SendEMandateBlock,
  BusinessConfiguration,
  BusinessStatusBlock,
  BusinessStatus,
  IntegrationConfiguration,
  BusinessConfigurationWarningBlock,
  SaleType,
  SaleLocation
};
